import React, { Component } from "react";
import PropTypes from "prop-types";

import { Fieldset, Field, Control, Label, Input } from "rbx";
import { Mutation } from "react-apollo";
import { ErrorMessage } from "../ErrorMessage";
import { UPDATE_EMPLOYEE_MUTATION } from "../../graphql/Employees/Employees.graphql";
import {
  BooleanInput,
  DateInput,
  LocationSelect,
  SystemCodeSelect,
  StateSelect,
  PoorTextEditor
} from "../inputs";
import EmployeeSelect from "./EmployeeSelect";
import Section from "../Section";
import { getUTCFormattedDate } from "../../utils";

class EditEmployeeForm extends Component {
  state = {
    RecId: "",
    EmployeeId: "",
    LastName: "",
    FirstName: "",
    MiddleName: "",
    Active: "",
    Address1: "",
    Address2: "",
    City: "",
    State: "",
    ZipCode: "",
    Country: "",
    HomePhoneNo: "",
    CellPhoneNo: "",
    AlternatePhoneNo: "",
    EmergencyPhoneNo: "",
    EmergencyContact: "",
    EmergencyRelationship: "",
    Email1: "",
    Email2: "",
    Veteran: "",
    PayrollId: "",
    SocialSecurityNo: "",
    JobTitle: "",
    BirthDate: "",
    HireDate: "",
    TrainingDate: "",
    TerminationDate: "",
    TerminationReasonRecIdRef: "",
    TerminationNote: "",
    RehireDate: "",
    PayrollNote: "",
    VacationDaysAllowedThisYear: "",
    VacationDaysRenewalDate: "",
    VacationDaysUsedThisYear: "",
    VacationDaysBalance: "",
    PersonalDaysAllowedThisYear: "",
    PersonalDaysRenewalDate: "",
    PersonalDaysUsedThisYear: "",
    PersonalDaysBalance: "",
    DriverFlag: "",
    DrugTest: "",
    HomeCompanyLocationId: "",
    SeniorityDate: "",
    SeniorityNo: "",
    Weight: "",
    LastWorkedDate: "",
    CompanyId: "",
    SupervisorRecIdRef: "",
    EthnicityRecIdRef: "",
    EmployeeTypeRecIdRef: "",
    ContactPreferenceRecIdRef: "",
    ...this.props.employee
  };

  onChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value });
  };

  // executed when the mutation finishes
  onUpdate = (cache, { data: { updateEmployee } }) => {
    this.setState({ ...updateEmployee });
  };

  render() {
    const {
      RecId,
      EmployeeId,
      LastName,
      FirstName,
      MiddleName,
      Active,
      Address1,
      Address2,
      City,
      State,
      ZipCode,
      Country,
      HomePhoneNo,
      CellPhoneNo,
      AlternatePhoneNo,
      EmergencyPhoneNo,
      EmergencyContact,
      EmergencyRelationship,
      Email1,
      Email2,
      Veteran,
      PayrollId,
      SocialSecurityNo,
      JobTitle,
      BirthDate,
      HireDate,
      TrainingDate,
      TerminationDate,
      TerminationReasonRecIdRef,
      TerminationNote,
      RehireDate,
      PayrollNote,
      VacationDaysAllowedThisYear,
      VacationDaysRenewalDate,
      VacationDaysUsedThisYear,
      VacationDaysBalance,
      PersonalDaysAllowedThisYear,
      PersonalDaysRenewalDate,
      PersonalDaysUsedThisYear,
      PersonalDaysBalance,
      DriverFlag,
      DrugTest,
      HomeCompanyLocationId,
      SeniorityDate,
      SeniorityNo,
      Weight,
      LastWorkedDate,
      CompanyId,
      SupervisorRecIdRef,
      EthnicityRecIdRef,
      EmployeeTypeRecIdRef,
      ContactPreferenceRecIdRef
    } = this.state;
    const { disabled } = this.props;
    return (
      <Mutation
        awaitRefetchQueries
        mutation={UPDATE_EMPLOYEE_MUTATION}
        refetchQueries={["ALL_EMPLOYEES_QUERY"]}
        update={this.onUpdate}
        variables={{
          data: {
            RecId,
            EmployeeId,
            LastName,
            FirstName,
            MiddleName,
            Active,
            Address1,
            Address2,
            City,
            State,
            ZipCode,
            Country,
            HomePhoneNo,
            CellPhoneNo,
            AlternatePhoneNo,
            EmergencyPhoneNo,
            EmergencyContact,
            EmergencyRelationship,
            Email1,
            Email2,
            Veteran,
            PayrollId,
            SocialSecurityNo,
            JobTitle,
            BirthDate: getUTCFormattedDate(BirthDate),
            HireDate: getUTCFormattedDate(HireDate),
            TrainingDate,
            TerminationDate: getUTCFormattedDate(TerminationDate),
            TerminationReasonRecIdRef: parseInt(TerminationReasonRecIdRef),
            TerminationNote,
            RehireDate: getUTCFormattedDate(RehireDate),
            PayrollNote,
            VacationDaysAllowedThisYear: parseInt(VacationDaysAllowedThisYear),
            VacationDaysRenewalDate: getUTCFormattedDate(
              VacationDaysRenewalDate
            ),
            VacationDaysUsedThisYear: parseInt(VacationDaysUsedThisYear),
            PersonalDaysAllowedThisYear: parseInt(PersonalDaysAllowedThisYear),
            PersonalDaysRenewalDate: getUTCFormattedDate(
              PersonalDaysRenewalDate
            ),
            PersonalDaysUsedThisYear: parseInt(PersonalDaysUsedThisYear),
            DriverFlag,
            DrugTest,
            HomeCompanyLocationId,
            SeniorityDate: getUTCFormattedDate(SeniorityDate),
            SeniorityNo,
            Weight: parseFloat(Weight),
            LastWorkedDate: getUTCFormattedDate(LastWorkedDate),
            CompanyId,
            SupervisorRecIdRef: parseInt(SupervisorRecIdRef),
            EthnicityRecIdRef: parseInt(EthnicityRecIdRef),
            EmployeeTypeRecIdRef: parseInt(EmployeeTypeRecIdRef),
            ContactPreferenceRecIdRef: parseInt(ContactPreferenceRecIdRef)
          },
          where: {
            RecId: this.props.employee.RecId
          }
        }}
      >
        {(updateEmployee, { loading, error }) => (
          <form
            id="edit-employee-form"
            method="POST"
            onSubmit={async e => {
              e.preventDefault();
              await updateEmployee();
            }}
          >
            <ErrorMessage error={error} />
            <Fieldset disabled={disabled || loading}>
              <Section size="small" title="Personal">
                <Field kind="group">
                  <Control>
                    <Label>Employee Id</Label>
                    <Input
                      disabled
                      autocomplete="new"
                      name="EmployeeId"
                      type="text"
                      value={EmployeeId}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <Label>First Name</Label>
                    <Input
                      autocomplete="new"
                      name="FirstName"
                      type="text"
                      value={FirstName}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <Label>Middle Name</Label>
                    <Input
                      autocomplete="new"
                      name="MiddleName"
                      type="text"
                      value={MiddleName}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <Label>Last Name</Label>
                    <Input
                      autocomplete="new"
                      name="LastName"
                      type="text"
                      value={LastName}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <SystemCodeSelect
                      icon="globe"
                      label="Ethnicity"
                      lookup={{ Category: "Employee", Code: "Ethnicity" }}
                      name="EthnicityRecIdRef"
                      value={EthnicityRecIdRef}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <Label>Veteran</Label>
                    <BooleanInput
                      name="Veteran"
                      value={Veteran}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field multiline kind="group">
                  <Control>
                    <Label>Address 1</Label>
                    <Input
                      autocomplete="new"
                      name="Address1"
                      type="text"
                      value={Address1}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <Label>Address 2</Label>
                    <Input
                      autocomplete="new"
                      name="Address2"
                      type="text"
                      value={Address2}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <Label>City</Label>
                    <Input
                      autocomplete="new"
                      name="City"
                      type="text"
                      value={City}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <Label>State</Label>
                    <StateSelect
                      name="State"
                      value={State}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <Label>Zip Code</Label>
                    <Input
                      autocomplete="new"
                      name="ZipCode"
                      type="text"
                      value={ZipCode}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <Label>Country</Label>
                    <Input
                      autocomplete="new"
                      name="Country"
                      type="text"
                      value={Country}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field kind="group">
                  <Control>
                    <Label>Home Phone No</Label>
                    <Input
                      autocomplete="new"
                      name="HomePhoneNo"
                      type="text"
                      value={HomePhoneNo}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <Label>Cell Phone No</Label>
                    <Input
                      autocomplete="new"
                      name="CellPhoneNo"
                      type="text"
                      value={CellPhoneNo}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <Label>Alternate Phone No</Label>
                    <Input
                      autocomplete="new"
                      name="AlternatePhoneNo"
                      type="text"
                      value={AlternatePhoneNo}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <SystemCodeSelect
                      icon="globe"
                      label="Contact Preference"
                      lookup={{
                        Category: "Employee",
                        Code: "ContactPreference"
                      }}
                      name="ContactPreferenceRecIdRef"
                      value={ContactPreferenceRecIdRef}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field kind="group">
                  <Control>
                    <Label>Emergency Phone No</Label>
                    <Input
                      autocomplete="new"
                      name="EmergencyPhoneNo"
                      type="text"
                      value={EmergencyPhoneNo}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <Label>Emergency Contact</Label>
                    <Input
                      autocomplete="new"
                      name="EmergencyContact"
                      type="text"
                      value={EmergencyContact}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <Label>Emergency Relationship</Label>
                    <Input
                      autocomplete="new"
                      name="EmergencyRelationship"
                      type="text"
                      value={EmergencyRelationship}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field kind="group">
                  <Control>
                    <Label>Email 1</Label>
                    <Input
                      autocomplete="new"
                      name="Email1"
                      type="text"
                      value={Email1}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <Label>Email 2</Label>
                    <Input
                      autocomplete="new"
                      name="Email2"
                      type="text"
                      value={Email2}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
              </Section>
              {/* PAYROLL */}
              <Section size="small" title="Payroll">
                <Field kind="group">
                  <Control>
                    <Label>Payroll Id</Label>
                    <Input
                      disabled
                      autocomplete="new"
                      name="PayrollId"
                      type="text"
                      value={PayrollId}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <Label>Employee Type</Label>
                    <SystemCodeSelect
                      icon="globe"
                      lookup={{
                        Category: "Employee",
                        Code: "EmployeeType"
                      }}
                      name="EmployeeTypeRecIdRef"
                      value={EmployeeTypeRecIdRef}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <Label>Social Security No</Label>
                    <Input
                      autocomplete="new"
                      name="SocialSecurityNo"
                      type="text"
                      value={SocialSecurityNo}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <Label>Job Title</Label>
                    <Input
                      autocomplete="new"
                      name="JobTitle"
                      type="text"
                      value={JobTitle}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <EmployeeSelect
                      icon="globe"
                      label="Supervisor"
                      name="SupervisorRecIdRef"
                      value={SupervisorRecIdRef}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field kind="group">
                  <Control>
                    <Label>Birth Date</Label>
                    <DateInput
                      name="BirthDate"
                      value={BirthDate}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <Label>Hire Date</Label>
                    <DateInput
                      name="HireDate"
                      value={HireDate}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <Label>Training Date</Label>
                    <DateInput
                      name="TrainingDate"
                      value={TrainingDate}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field kind="group">
                  <Control>
                    <Label>Termination Date</Label>
                    <DateInput
                      name="TerminationDate"
                      value={TerminationDate}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <SystemCodeSelect
                      icon="globe"
                      label="Termination Reason"
                      lookup={{ Category: "Employee", Code: "TermReason" }}
                      name="TerminationReasonRecIdRef"
                      value={TerminationReasonRecIdRef}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <Label>Rehire Date</Label>
                    <DateInput
                      name="RehireDate"
                      value={RehireDate}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field>
                  <Control>
                    <Label>Termination Note</Label>
                    <PoorTextEditor
                      name="TerminationNote"
                      value={TerminationNote}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field>
                  <Control>
                    <Label>Payroll Note</Label>
                    <PoorTextEditor
                      name="PayrollNote"
                      value={PayrollNote}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
              </Section>
              {/* VACATION / PERSONAL */}
              <Section size="small" title="Vacation">
                <Field kind="group">
                  <Control>
                    <Label>Vacation Days Allowed This Year</Label>
                    <Input
                      autocomplete="new"
                      name="VacationDaysAllowedThisYear"
                      type="number"
                      value={VacationDaysAllowedThisYear}
                      onChange={this.onChange}
                    />
                  </Control>

                  <Control>
                    <Label>Vacation Days Used This Year</Label>
                    <Input
                      autocomplete="new"
                      name="VacationDaysUsedThisYear"
                      type="number"
                      value={VacationDaysUsedThisYear}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <Label>Vacation Days Balance</Label>
                    <Input
                      disabled
                      autocomplete="new"
                      name="VacationDaysBalance"
                      type="number"
                      value={VacationDaysBalance}
                    />
                  </Control>
                  <Control>
                    <Label>Vacation Days Renewal Date</Label>
                    <DateInput
                      name="VacationDaysRenewalDate"
                      value={VacationDaysRenewalDate}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field kind="group">
                  <Control>
                    <Label>Personal Days Allowed This Year</Label>
                    <Input
                      autocomplete="new"
                      name="PersonalDaysAllowedThisYear"
                      type="number"
                      value={PersonalDaysAllowedThisYear}
                      onChange={this.onChange}
                    />
                  </Control>

                  <Control>
                    <Label>Personal Days Used This Year</Label>
                    <Input
                      autocomplete="new"
                      name="PersonalDaysUsedThisYear"
                      type="number"
                      value={PersonalDaysUsedThisYear}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <Label>Personal Days Balance</Label>
                    <Input
                      disabled
                      autocomplete="new"
                      name="PersonalDaysBalance"
                      type="number"
                      value={PersonalDaysBalance}
                    />
                  </Control>
                  <Control>
                    <Label>Personal Days Renewal Date</Label>
                    <DateInput
                      name="PersonalDaysRenewalDate"
                      value={PersonalDaysRenewalDate}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
              </Section>
              {/* DRIVER */}
              <Section size="small" title="Driver">
                <Field kind="group">
                  <Control>
                    <Label>Seniority Date</Label>
                    <DateInput
                      name="SeniorityDate"
                      value={SeniorityDate}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <Label>Seniority No</Label>
                    <Input
                      autocomplete="new"
                      name="SeniorityNo"
                      type="number"
                      value={SeniorityNo}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <Label>Weight</Label>
                    <Input
                      autocomplete="new"
                      name="Weight"
                      type="number"
                      value={Weight}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <Label>Last Worked Date</Label>
                    <DateInput
                      name="LastWorkedDate"
                      value={LastWorkedDate}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field kind="group">
                  <Control>
                    <Label>Driver Flag</Label>
                    <BooleanInput
                      name="DriverFlag"
                      value={DriverFlag}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <Label>Drug Test</Label>
                    <BooleanInput
                      name="DrugTest"
                      value={DrugTest}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <LocationSelect
                      icon="globe"
                      label="Home Company Location"
                      name="HomeCompanyLocationId"
                      value={HomeCompanyLocationId}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
              </Section>
            </Fieldset>
          </form>
        )}
      </Mutation>
    );
  }
}

EditEmployeeForm.propTypes = {
  employee: PropTypes.object,
  disabled: PropTypes.bool
};
EditEmployeeForm.defaultProps = {};

export default EditEmployeeForm;
